document.querySelector('.product-gallery scroll-carousel').addEventListener('carousel:settle', function(event) {
    let carouselIndex = event.detail.index + 1;    
    let carouselDotsCount = document.querySelectorAll('.product-gallery carousel-navigation').childElementCount;  
    if (carouselIndex == this.childElementCount) {
      document.querySelectorAll('.product-gallery carousel-navigation > .tap-area')[0].click();
    }
});